import { NoteType } from '@museflow-ai/opensheetmusicdisplay';
import Scheduler from './Scheduler';
import { isNativeTimeKeeper } from 'Models/createTimeKeeper';

export default class Scheduler2 extends Scheduler {
  unpauseTicks = (
    bpm: number,
    countInMeasures: number,
    startMeasure: number,
    tickNoteType: NoteType,
    absoluteTiming: boolean = false,
  ): Promise<void> | void => {
    console.log(
      '[Scheduler2.unpauseTicks] called, isPaused=',
      this.timeKeeper.isPaused(),
      'handlingPauseOrUnpause=',
      this.handlingPauseOrUnpause,
      'isNative=',
      isNativeTimeKeeper(this.timeKeeper),
      'bpm=',
      bpm,
      'startMeasure=',
      startMeasure,
      'absoluteTiming=',
      absoluteTiming,
    );
    if (!this.timeKeeper.isPaused() || this.handlingPauseOrUnpause) {
      console.log(
        '[Scheduler2.unpauseTicks] BAILING OUT — isPaused=',
        this.timeKeeper.isPaused(),
        'handlingPauseOrUnpause=',
        this.handlingPauseOrUnpause,
      );
      return;
    }
    this.handlingPauseOrUnpause = true;

    const elapsedTicks = this.timeKeeper?.calculateElapsedTicks();
    const numberOfTicksPerMeasure = this.timeKeeper.getTicksPerMeasure();

    let lastCompleteMeasure = Math.floor(elapsedTicks / numberOfTicksPerMeasure);
    if (isNaN(lastCompleteMeasure) || lastCompleteMeasure < 0) {
      lastCompleteMeasure = this.countInMeasures;
    }
    const measureOffset = absoluteTiming ? startMeasure : this.lastPauseMeasure;
    console.log(
      '[Scheduler2.unpauseTicks] proceeding: measureOffset=',
      measureOffset,
      'lastPauseMeasure=',
      this.lastPauseMeasure,
      'startMeasure=',
      startMeasure,
    );

    if (isNativeTimeKeeper(this.timeKeeper)) {
      // Native path: startNativeScheduler owns the unpause + start sequence
      // because it must fetch native time before calling unpause().
      // Return the promise so callers can await native scheduler completion
      // before processing queued MIDI events (fixes first-note-always-miss).
      console.log(
        '[Scheduler2.unpauseTicks] starting native scheduler with measureOffset=',
        measureOffset,
      );
      return this.startNativeScheduler(bpm, 0, measureOffset, tickNoteType).then(() => {
        for (const unpauseCb of this.unpauseFns) {
          unpauseCb(
            this.timeKeeper?.calculateElapsedTicks(),
            this.timeKeeper?.getPlaybackStartTicks(),
            this.timeKeeper?.getTicksPerMeasure(),
          );
        }
        this.handlingPauseOrUnpause = false;
      });
    } else {
      this.timeKeeper.unpause(bpm, 0, measureOffset, tickNoteType);
      this.lastScheduledBeat = -10000;
      this.scheduleMetronomeAudio();
      this.tickIntervalFn = this._startTickIntervalLoop();

      for (const unpauseCb of this.unpauseFns) {
        unpauseCb(
          this.timeKeeper?.calculateElapsedTicks(),
          this.timeKeeper?.getPlaybackStartTicks(),
          this.timeKeeper?.getTicksPerMeasure(),
        );
      }

      this.handlingPauseOrUnpause = false;
    }
  };
}
